import { render, staticRenderFns } from "./InstancesList.vue?vue&type=template&id=45c7b42a&scoped=true&"
import script from "./InstancesList.vue?vue&type=script&lang=js&"
export * from "./InstancesList.vue?vue&type=script&lang=js&"
import style0 from "./InstancesList.vue?vue&type=style&index=0&id=45c7b42a&prod&lang=scss&scoped=true&"
import style1 from "./InstancesList.vue?vue&type=style&index=1&id=45c7b42a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7b42a",
  null
  
)

export default component.exports